import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import { useGame } from "../../backend/useGame";
import GamePreview from "./components/GamePreview";
import { useConfig } from "../../utils/config";
import { GithubFormat } from "./utils/formatCode";
import EditBadge from "./components/EditBadge";
import { useUser } from "../../backend/useUser";
import { captureEvent } from "../../utils/analytics";
import { useGameMetrics } from "../../backend/useGameMetrics";

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100svh;
    background-color: ${Colors.black};
    color: ${Colors.white};
    padding: 5px;
    gap: 10px;
`;

const BadgeContainer = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const TestPlay = () => {
    const config = useConfig();
    const { user } = useUser();
    const { gameId: urlGameId } = useParams();
    const location = useLocation();
    const game = useGame();
    const gameMetrics = useGameMetrics();
    const [code, setCode] = useState<GithubFormat>([]);
    const [isMyGame, setIsMyGame] = useState(false);
    const [showEditBadge, setShowEditBadge] = useState(true);

    // Store the game data to check ownership when user data is available
    const [gameData, setGameData] = useState(null);

    // Load game if we have a game ID
    useEffect(() => {
        const loadGame = async () => {
            if (!urlGameId) return;

            try {
                // Get game by ID
                const existingGame = await game.getGame(urlGameId);
                // console.log('game:', existingGame);
                
                // Store the game data for ownership check
                setGameData(existingGame);
                
                if (existingGame && Array.isArray(existingGame.game_history_entries)) {
                    const gameHistory = existingGame.game_history_entries;
                    
                    // Set the current code to the last history entry
                    const currentEntry = gameHistory[gameHistory.length - 1];
                    if (currentEntry) {
                        setCode(currentEntry.code);
                    }
                }
            } catch (error) {
                console.error('Error loading game:', error);
            }
        };

        if (urlGameId) {
            loadGame();
        }
    }, [urlGameId]);
    
    // Check for screenshot parameter in URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        setShowEditBadge(!searchParams.has('screenshot'));
    }, [location.search]);

    return (
        <Root>
            <GamePreview 
                config={config}
                key="play"
                mode="Play" 
                code={code} 
            />
        </Root>
    );
};

export default TestPlay;
